import { jsx as _jsx } from "react/jsx-runtime";
import { StatusIndicator } from '../../../components/StatusIndicator';
import { StatusItemAnalise } from '../../../enums/analise.enum';
export var StatusAnaliseIndicator = function (_a) {
    var status = _a.status;
    if (!status || status === StatusItemAnalise.NAO_ANALISADO) {
        return null;
    }
    return (_jsx(StatusIndicator, { status: status === StatusItemAnalise.APROVADO ? 'success' : 'warning', message: status === StatusItemAnalise.APROVADO ? 'Aprovado' : 'Reprovado' }));
};
